/**
 * Rob (VP Sales) / owner 2026-10-30 (migration 1280): the Lead / Event Rep stays optional, but a new event needs at
 * least ONE of the Team step's Territory Manager, Regional Manager or Sales Director boxes -- the managers fill the lead
 * later from the schedules. Behind the server switch system_config.event_team_position_required (off until the AD
 * hierarchy exists); the database trigger enforces the same rule for every creation path.
 * Not retroactive: an existing event that never had one can be saved as it is; one that had a box may not lose the last.
 */
export const TEAM_POSITION_REQUIRED_MESSAGE =
  "Choose a Territory Manager, Regional Manager or Sales Director (at least one). The Lead / Event Rep can stay open.";

export interface TeamBoxes {
  tmId?: string | null;
  rmId?: string | null;
  sdId?: string | null;
}

export function hasTeamPosition(c: TeamBoxes): boolean {
  return !!(c.tmId || c.rmId || c.sdId);
}

/** The error to show on the Team step, or null. `existingHadOne` is null when creating a new event. */
export function teamPositionError(
  required: boolean,
  current: TeamBoxes,
  existingHadOne: boolean | null,
): string | null {
  if (!required || hasTeamPosition(current)) {
    return null;
  }
  if (existingHadOne === false) {
    return null;
  } // an older event with none: not retroactive
  return TEAM_POSITION_REQUIRED_MESSAGE;
}
